import React from 'react'

import makeStyles from '@material-ui/styles/makeStyles'
import InputLabel from '@material-ui/core/InputLabel'

import { useGlobalState } from '../store'

import type { GlobalState } from '../types/globalState'

const useStyles = makeStyles({
  main: {
    color: '#222120',
    margin: '0 0 1vh 0',
  },
})

const CustomLabel = ({
  children,
  style = {},
  className,
  infoLink = '',
  infoText = '',
  toUpperCase = false,
}) => {
  const [theme]: GlobalState = useGlobalState('theme')
  const classes = useStyles({ theme })
  return (
    <InputLabel style={{ fontSize: 13, ...style }} className={(classes.main, className)}>
      {!toUpperCase && typeof children === 'string' ? children.toUpperCase() : children}
      {!!infoLink && !!infoText && (
        <div onClick={infoLink} style={{ color: theme.colors.buttonTextNext, cursor: 'pointer' }}>
          {infoText}
        </div>
      )}
    </InputLabel>
  )
}

export default CustomLabel
